import { connect } from "react-redux";
import { pick, union } from "ramda";
import { refreshView as refreshViewAction } from "ra-core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Modal from "@material-ui/core/Modal";
import React from "react";
import ReactFileReader from "react-file-reader";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import { MuiPickersUtilsProvider, DatePicker } from "material-ui-pickers";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import moment from "moment";
import ExampleBill from "../../statics/ExampleBill.csv";
import {
	List,
	Datagrid,
	TextField,
	EditButton,
	ShowButton,
	CardActions,
	CreateButton,
	RefreshButton,
	ReferenceField,
	Filter,
	TextInput,
	ReferenceArrayInput,
	SelectArrayInput,
	ChipField,
	DateField
} from "react-admin";
import { HOST } from "../../configs/index";
import uploadService from "../../services/uploadService";
import { SUPERADMIN } from "../../constant/TypeRole";
import Actions from "../Actions";

const BillFilter = props => {
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
	return (
		<Filter {...props}>
			{/* <TextInput source="name_contains" /> */}
			<ReferenceArrayInput
				alwaysOn
				style={{ minWidth: "200px" }}
				source="project"
				reference="project"
				filter={filter}
			>
				<SelectArrayInput optionText="name" />
			</ReferenceArrayInput>
		</Filter>
	);
};

export class BillList extends React.Component {
  state = {
  	allProject: []
  }
  componentDidMount() {
  	const token = localStorage.getItem("token");
  	fetch(`${HOST}/project`, {
  		headers: new Headers({
  			Authorization: `Bearer ${token}`
  		}),
  	})
  		.then(response => response.json())
  		.then(data => this.setState({ allProject: data }));
  }
  render() {
  	const props = this.props;
  	const role = localStorage.getItem("role");
  	const project = JSON.parse(localStorage.getItem("project"));
  	const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
  	return (
  		<List
  			{...props}
  			title="bill.bill"
  			bulkActions={false}
  			actions={<RoomActions allProject={this.state.allProject} />}
  			filters={<BillFilter />}
  			filterDefaultValues={filter}
  		>
  			<Datagrid>
  				<div />
  				<ReferenceField linkType={false} source="project" reference="project">
  					<ChipField source="name" />
  				</ReferenceField>
  				<ReferenceField linkType={false} source="room" reference="room">
  					<TextField source="name" />
  				</ReferenceField>
  				<DateField source="date" locales="th-TH" options={{ year: "numeric", month: "long" }} />
  				<EditButton />
  			</Datagrid>
  		</List>
  	);
  }
}


const mapStateToProps = state => ({
	// allProject: state.admin.resources.project.data
});
const enhance = connect(
	mapStateToProps,
	{ refreshView: refreshViewAction }
);
const RoomActions = enhance(
	class RoomActions extends React.Component {
    state = {
    	loading: false,
    	open: false,
    	files: null,
    	project: "",
    	date: moment(),
    };
    handleOpen = () => this.setState({ open: true });
    handleClose = () =>
    	this.setState({ open: false, project: "", files: null });
    setLoading = (loading = false) => this.setState({ loading });
    render() {
    	const { loading, files, project, date } = this.state;
    	const {
    		resource,
    		filters,
    		displayedFilters,
    		filterValues,
    		basePath,
    		showFilter,
    		allProject
    	} = this.props;
    	const role = localStorage.getItem("role");
    	const myProject = JSON.parse(localStorage.getItem("project"));
    	const pickProject =
        role === SUPERADMIN ? allProject : union(myProject, allProject);
    	return (
    		<CardActions>
    			{filters &&
            React.cloneElement(filters, {
            	resource,
            	showFilter,
            	displayedFilters,
            	filterValues,
            	context: "button"
            })}
    			<CreateButton basePath={basePath} />
    			<RefreshButton />
    			<Button
    				onClick={this.handleOpen}
    				primary="true"
    				style={{ color: "#3f51b5" }}
    			>
            Import Bill CSV
    			</Button>

    			<Modal
    				aria-labelledby="simple-modal-title"
    				aria-describedby="simple-modal-description"
    				open={this.state.open}
    			>
    				<div
    					style={{
    						position: "relative",
    						backgroundColor: "white",
    						padding: "20px",
    						borderRadius: "4px",
    						width: "70%",
    						margin: "0 auto",
    						minHeight: "300px",
    						top: "20%"
    					}}
    				>
    					<Typography variant="title" id="modal-title">
                Import bill by CSV
    					</Typography>
    					<Typography variant="subheading" id="simple-modal-description" />
    					<div style={{ marginTop: 20 }}>
    						<a href={ExampleBill}>Download Example bill</a>
    					</div>
    					<FormControl required style={{ width: 300, marginTop: 20 }}>
    						<InputLabel htmlFor="age-simple">Project</InputLabel>
    						<Select
    							value={this.state.project}
    							onChange={({ target: { value } }) =>
    								this.setState({ project: value })
    							}
    							input={<Input id="project-simple" />}
    						>
    							{pickProject.map(p => (
    								<MenuItem key={p._id} value={p._id}>
    									{p.name}
    								</MenuItem>
    							))}
    						</Select>
    						<MuiPickersUtilsProvider utils={MomentUtils}>
    							<DatePicker
    								margin="normal"
    								label="บิลประจำเดือน"
    								value={this.state.date}
    								onChange={(date) => this.setState({ date })}
    								labelFunc={(date) => date.format("MMMM YYYY")}
    							/>
    						</MuiPickersUtilsProvider>
    						<FormHelperText>Required</FormHelperText>
    					</FormControl>
    					<div style={{ marginTop: 30 }}>
    						<ReactFileReader
    							fileTypes={[".csv"]}
    							handleFiles={files => this.setState({ files })}
    						>
    							<Button variant="raised" component="span">
                    Choose file
    							</Button>
    							{files &&
                    files[0] &&
                    files[0].name && (
    								<span style={{ marginLeft: 10 }}>{files[0].name}</span>
    							)}
    						</ReactFileReader>
    					</div>
    					<div style={{ position: "absolute", bottom: 20, right: 30 }}>
    						<Button
    							primary="true"
    							style={{ color: "red" }}
    							onClick={this.handleClose}
    						>
                  Cancel
    						</Button>
    						<Button
    							primary="true"
    							style={{ color: "#3f51b5" }}
    							onClick={() =>
    								project && files
    									? importRoom(
    										files,
    										project,
    										date,
    										this.setLoading,
    										this.props.refreshView,
    										this.handleClose
    									)
    									: alert("Please select Project & CSV file")
    							}
    						>
                  UPLOAD
    						</Button>
    					</div>
    				</div>
    			</Modal>
    			<Loading open={loading} />
    		</CardActions>
    	);
    }
	}
);

const Loading = ({ ...other }) => (
	<Dialog {...other}>
		<DialogTitle id="simple-dialog-title">Loading...</DialogTitle>
		<div style={{ textAlign: "center", marginBottom: 20, height: 50 }}>
			<CircularProgress />
		</div>
	</Dialog>
);

const importRoom = (files, project, date, setLoading, refreshView, closeModal) => {
	setLoading(true);
	uploadService([{ rawFile: files[0] }]).then(res => {
		const token = localStorage.getItem("token");
		const fecthOption = {
			method: "POST",
			headers: {
				Authorization: `Bearer ${token}`
			}
		};
		const formData = new FormData();
		formData.append("csv", res.url);
		formData.append("project", project);
		formData.append("date", date.format("MM/YYYY"));
		fecthOption.body = formData;
		fetch(`${HOST}/bill`, fecthOption)
			.then(response => response.json())
			.then(responseJson => {
				setLoading(false);
				closeModal();
				setTimeout(() => refreshView(), 1000);
				alert(`Success ${responseJson ? responseJson.length || 0 : 0} rows`);
			})
			.catch(error => {
				setLoading(false);
				alert("Error");
			});
	});
};



// WEBPACK FOOTER //
// ./src/components/bill/BillList.js